import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, minWidth, Text } from '@calm-web/design-system';

import { cardRatioCSS } from '@/components/app/cards/ContentCard/styles';

export const Wrapper = styled.div<{
	isSelected: boolean;
}>`
	${cardRatioCSS}
	border-radius: 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
	position: relative;

	${minWidth('desktop')} {
		&:hover {
			&:after {
				opacity: 1;
			}
		}
	}

	button:after {
		${p => (p.isSelected ? 'opacity: 1' : '')};
	}
`;

export const BackgroundImage = styled.div`
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	z-index: -1;
	border-radius: 16px;
	overflow: hidden;
	cursor: context-menu;
`;

export const ContentOverlay = styled.div`
	background: rgba(0, 0, 0, 0.4);
	backdrop-filter: blur(36px);
	color: ${palette('white')};
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 8px 12px;
	margin-top: auto;
	width: 100%;
	text-align: initial;
	line-height: normal;
	border-bottom-right-radius: 16px;
	border-bottom-left-radius: 16px;
	overflow: hidden;
`;

export const Title = styled(Text).attrs({
	el: 'h2',
	styleAs: 'h5',
})`
	font-size: 16px;
	font-weight: 500;
	margin-top: 0;
	margin-bottom: 2px;
`;

export const ClickTarget = styled(Button).attrs({
	backgroundColor: 'transparent',
})`
	width: 100%;
	height: 100%;
	padding: 0;
	&:after {
		border-radius: 16px;
	}
	&& {
		&:before {
			opacity: 0;
		}
	}
`;
